import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { DSQObservationReport } from "../../Api/Dsq/Dto/Responses/MyleDSQResultsResponse";

class MyleDSQLab implements ITableDataSourceItem<DSQObservationReport> {
    public Model: DSQObservationReport;
    public IsSelected: boolean;
    public Name: string;
    public isChecked: boolean;

    constructor(model: DSQObservationReport) {
        this.Model = model;
        this.IsSelected = false;
        this.isChecked = false;
    }
}

class MyleDSQDocumentRequestModel {
    public SILID: string;
    public SILOID: string;
    public ReportTypes: string[];
    public Category: string;
}

class MyleDSQLabImgRequestModel {
    public IsImaging: boolean;
    public Documents: MyleDSQDocumentRequestModel[];
}

export { MyleDSQDocumentRequestModel, MyleDSQLab, MyleDSQLabImgRequestModel };
